(function() {
  function initScrollTop() {
    var scrollTop = document.getElementById('scroll__top');
    if (scrollTop && !scrollTop.getAttribute('data-bound')) {
      scrollTop.setAttribute('data-bound', 'true');
      scrollTop.addEventListener('click', function(e) {
        e.preventDefault();
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
      });

      window.addEventListener('scroll', function() {
        if (window.scrollY > 300) {
          scrollTop.classList.add("active");
        } else {
          scrollTop.classList.remove("active");
        }
      }, { passive: true });
    }

    // Automatically remove conflicting duplicate scroll-to-top elements from apps (e.g. Findter)
    var duplicates = document.querySelectorAll('fdt-scroll-to-top, .search-filters__scroll-to-top-btn, [class*="scroll-to-top"]:not(#scroll__top), .back-to-top:not(#scroll__top)');
    for (var i = 0; i < duplicates.length; i++) {
      duplicates[i].remove();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollTop);
  } else {
    initScrollTop();
  }

  // MutationObserver to catch dynamically injected third-party return-to-top buttons
  try {
    var obs = new MutationObserver(function() {
      var duplicates = document.querySelectorAll('fdt-scroll-to-top, .search-filters__scroll-to-top-btn, [class*="scroll-to-top"]:not(#scroll__top)');
      for (var i = 0; i < duplicates.length; i++) {
        duplicates[i].remove();
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function() { obs.disconnect(); }, 15000);
  } catch (err) {}
})(); 